import type { ModelProductOperation } from '@app/api/Products';

export const getOperationRowKey = (
  operation: ModelProductOperation
): string => {
  const { DocumentId, Timestamp, ProductId, WarehouseId, SupplierId, UserId } =
    operation;

  return [
    DocumentId,
    Timestamp,
    ProductId,
    WarehouseId,
    SupplierId ?? 'null',
    UserId,
  ].join('-');
};
